/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateKdsDeviceRequest
 */
export interface UpdateKdsDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateKdsDeviceRequest
     */
    platform?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKdsDeviceRequest
     */
    osVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKdsDeviceRequest
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKdsDeviceRequest
     */
    appVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKdsDeviceRequest
     */
    webviewVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKdsDeviceRequest
     */
    nativeVersion?: string;
}

/**
 * Check if a given object implements the UpdateKdsDeviceRequest interface.
 */
export function instanceOfUpdateKdsDeviceRequest(value: object): value is UpdateKdsDeviceRequest {
    return true;
}

export function UpdateKdsDeviceRequestFromJSON(json: any): UpdateKdsDeviceRequest {
    return UpdateKdsDeviceRequestFromJSONTyped(json, false);
}

export function UpdateKdsDeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateKdsDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'] == null ? undefined : json['platform'],
        'osVersion': json['osVersion'] == null ? undefined : json['osVersion'],
        'model': json['model'] == null ? undefined : json['model'],
        'appVersion': json['appVersion'] == null ? undefined : json['appVersion'],
        'webviewVersion': json['webviewVersion'] == null ? undefined : json['webviewVersion'],
        'nativeVersion': json['nativeVersion'] == null ? undefined : json['nativeVersion'],
    };
}

export function UpdateKdsDeviceRequestToJSON(json: any): UpdateKdsDeviceRequest {
    return UpdateKdsDeviceRequestToJSONTyped(json, false);
}

export function UpdateKdsDeviceRequestToJSONTyped(value?: UpdateKdsDeviceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'osVersion': value['osVersion'],
        'model': value['model'],
        'appVersion': value['appVersion'],
        'webviewVersion': value['webviewVersion'],
        'nativeVersion': value['nativeVersion'],
    };
}

